var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Bitecs, Component, BitecsSchema, type, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let TransformSchema = class extends BitecsSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "_x");
    __publicField(this, "_y");
    __publicField(this, "_z");
    __publicField(this, "_previousX");
    __publicField(this, "_previousY");
    __publicField(this, "_previousZ");
  }
  static get x() {
    return TransformSchema.store.x[this.id];
  }
  get x() {
    return TransformSchema.x;
  }
  static set x(value) {
    if (TransformSchema.store.x[this.id] !== value) {
      TransformSchema.store.x[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 1;
    }
  }
  set x(value) {
    TransformSchema.x = value;
  }
  static get y() {
    return TransformSchema.store.y[this.id];
  }
  get y() {
    return TransformSchema.y;
  }
  static set y(value) {
    if (TransformSchema.store.y[this.id] !== value) {
      TransformSchema.store.y[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 2;
    }
  }
  set y(value) {
    TransformSchema.y = value;
  }
  static get position() {
    return { x: TransformSchema.x, y: TransformSchema.y };
  }
  get position() {
    return TransformSchema.position;
  }
  static set position(value) {
    TransformSchema.x = value.x;
    TransformSchema.y = value.y;
  }
  set position(value) {
    TransformSchema.position = value;
  }
  static get previousPosition() {
    return { x: TransformSchema.previousX, y: TransformSchema.previousY };
  }
  get previousPosition() {
    return TransformSchema.previousPosition;
  }
  static get z() {
    return TransformSchema.store.z[this.id];
  }
  get z() {
    return TransformSchema.z;
  }
  static set z(value) {
    if (TransformSchema.store.z[this.id] !== value) {
      TransformSchema.store.z[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 4;
    }
  }
  set z(value) {
    TransformSchema.z = value;
  }
  static get previousX() {
    return TransformSchema.store.previousX[this.id];
  }
  get previousX() {
    return TransformSchema.previousX;
  }
  static set previousX(value) {
    if (TransformSchema.store.previousX[this.id] !== value) {
      TransformSchema.store.previousX[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 8;
    }
  }
  set previousX(value) {
    TransformSchema.previousX = value;
  }
  static get previousY() {
    return TransformSchema.store.previousY[this.id];
  }
  get previousY() {
    return TransformSchema.previousY;
  }
  static set previousY(value) {
    if (TransformSchema.store.previousY[this.id] !== value) {
      TransformSchema.store.previousY[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 16;
    }
  }
  set previousY(value) {
    TransformSchema.previousY = value;
  }
  static get previousZ() {
    return TransformSchema.store.previousZ[this.id];
  }
  get previousZ() {
    return TransformSchema.previousZ;
  }
  static set previousZ(value) {
    if (TransformSchema.store.previousZ[this.id] !== value) {
      TransformSchema.store.previousZ[this.id] = value;
      TransformSchema.store.__changes[this.id] |= 32;
    }
  }
  set previousZ(value) {
    TransformSchema.previousZ = value;
  }
};
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_x", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_y", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_z", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_previousX", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_previousY", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], TransformSchema.prototype, "_previousZ", 2);
TransformSchema = __decorateClass([
  Bitecs(),
  Component("Transform")
], TransformSchema);
const __vite_glob_0_18 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TransformSchema() {
    return TransformSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  TransformSchema as T,
  __vite_glob_0_18 as _
};
//# sourceMappingURL=Transform-9450b7b5.js.map
